/* Product configurator section (sections/product-configurator.liquid). A four-step wizard in one
   stage, one step at a time behind a back button: 1 and 2 are the products-page finder's two
   questions (the same recommendation rules, copied below), 3 the recommendation with the close
   alternatives as chips above that product's panel, 4 the panel's quote form. A tile chosen by
   pointer advances at once; from the keyboard the arrow keys only move the selection and Enter or
   Space advances, so question two can be browsed. The panel's option tiles resolve to a real
   variant (a pick with no matching variant snaps the other options to the closest one that
   exists, and says so), tile prices stay live, quantity drives the total (VAT-inclusive for UK buyers), the cart
   form posts natively and the quote form posts the visitor's note with the configuration block
   appended. configurator_* events go straight to dataLayer, gtag, Shopify pixels and Clarity,
   never through the hero A/B layer (still running on live), so they carry no hero_variant. Vanilla, deferred,
   idempotent; re-inits in the theme editor. */
(function () {
  'use strict';
  if (window.__pcInit) return;
  window.__pcInit = true;
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var currency = function () { return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP'; };
  /* prices come precomputed from Liquid (snippets/price-vat.liquid, 30 Sep 2026): pt is the
     variant's main unit figure (VAT-inclusive for UK visitors on taxable variants, net for
     everyone else) and tot[q - 1] the main total for q units, so there is no VAT maths or
     currency formatting here */
  var tot = function (v, q) { return (v.tot && v.tot[q - 1]) || v.pt || ''; };
  var low = function (s) { return s.replace(/^[A-Z][a-z]/, function (m) { return m.toLowerCase(); }); };
  /* runs after Shopify's captcha bootstrap, whose DOMContentLoaded listener (registered in <head>) refills every
     contact form after a spam challenge; a deferred script runs before DOMContentLoaded, so wait for it */
  function ready(fn) {
    var done = false, run = function () { if (!done) { done = true; fn(); } };
    if (document.readyState === 'complete') return run();
    document.addEventListener('DOMContentLoaded', run);
    window.addEventListener('load', run);
  }

  function emit(name, params) {
    var p = params || {};
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, p)); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, p); } catch (e) {}
    try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(name, p); } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
  }

  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* step motion: the arriving view slides in from the side it comes from and the leaving one slips out the other way;
     the product step's result bar and windows then rise in one after another. None of it under reduced motion */
  var EASE = 'cubic-bezier(.2, 0, 0, 1)';
  var slideIn = function (el, dx) { if (!reduced && el.animate) el.animate([{ opacity: 0, transform: 'translateX(' + dx + 'px)' }, { opacity: 1, transform: 'none' }], { duration: 320, easing: EASE }); };
  var fadeUp = function (el) { if (!reduced && el.animate) el.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: 240, easing: EASE }); };
  var rise = function (view) {
    if (reduced || !view.animate) return;
    [].forEach.call(view.querySelectorAll('.pc-result, .pc__panel:not([hidden]) > .pc__window'), function (el, i) {
      el.animate([{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'none' }], { duration: 360, delay: 60 + i * 70, easing: EASE, fill: 'backwards' });
    });
  };
  var MARK = 'Quote request from the product configurator';
  var esc = function (v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var has = function (o, k) { return Object.prototype.hasOwnProperty.call(o, k); };

  /* the rules mirror the products finder in products-showcase.js (change both); the tile icons are this
     section's own: Lucide (lucide.dev), except the three network glyphs drawn to match. Lucide licence (ISC):
     Copyright (c) for portions of Lucide are held by Cole Bemis 2013-2022 as part of Feather (MIT). All other copyright
     (c) for Lucide are held by Lucide Contributors 2022. Permission to use, copy, modify, and/or distribute this software
     for any purpose with or without fee is hereby granted, provided that the above copyright notice and this permission
     notice appear in all copies. THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD TO
     THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE
     FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA
     OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION
     WITH THE USE OR PERFORMANCE OF THIS SOFTWARE. */
  var FINDER = (function () {
    var ICON = {
      lanes1: '<path d="M3 12h18"/><rect x="9.75" y="9.75" width="4.5" height="4.5" rx="1" fill="currentColor" stroke="none"/>',
      lanes2: '<path d="M3 8h18"/><path d="M3 16h18"/><rect x="5.75" y="5.75" width="4.5" height="4.5" rx="1" fill="currentColor" stroke="none"/><rect x="13.75" y="13.75" width="4.5" height="4.5" rx="1" fill="currentColor" stroke="none"/>',
      lanes4: '<path d="M3 4.5h18"/><path d="M3 9.5h18"/><path d="M3 14.5h18"/><path d="M3 19.5h18"/><rect x="4.75" y="2.25" width="4.5" height="4.5" rx="1" fill="currentColor" stroke="none"/><rect x="11.75" y="7.25" width="4.5" height="4.5" rx="1" fill="currentColor" stroke="none"/><rect x="7.75" y="12.25" width="4.5" height="4.5" rx="1" fill="currentColor" stroke="none"/><rect x="14.75" y="17.25" width="4.5" height="4.5" rx="1" fill="currentColor" stroke="none"/>',
      diag: '<path d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"/>',
      question: '<circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/>',
      thermo: '<path d="M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z"/>',
      wave: '<path d="M2 13a2 2 0 0 0 2-2V7a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0V4a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0v-4a2 2 0 0 1 2-2"/>',
      layers: '<path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z"/><path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12"/><path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17"/>',
      few: '<path d="M10 5H3"/><path d="M12 19H3"/><path d="M14 3v4"/><path d="M16 17v4"/><path d="M21 12h-9"/><path d="M21 19h-5"/><path d="M21 5h-7"/><path d="M8 10v4"/><path d="M8 12H3"/>',
      upload: '<path d="M12 13v8"/><path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"/><path d="m8 17 4-4 4 4"/>',
      chip: '<path d="M12 20v2"/><path d="M12 2v2"/><path d="M17 20v2"/><path d="M17 2v2"/><path d="M2 12h2"/><path d="M2 17h2"/><path d="M2 7h2"/><path d="M20 12h2"/><path d="M20 17h2"/><path d="M20 7h2"/><path d="M7 20v2"/><path d="M7 2v2"/><rect x="4" y="4" width="16" height="16" rx="2"/><rect x="8" y="8" width="8" height="8" rx="1"/>',
      drive: '<path d="M10 16h.01"/><path d="M2.212 11.577a2 2 0 0 0-.212.896V18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5.527a2 2 0 0 0-.212-.896L18.55 5.11A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/><path d="M21.946 12.013H2.054"/><path d="M6 16h.01"/>',
    };
    var KB = 'k-box-multi-daq-can-bus-instrumentation-module';
    var Q2 = {
      record: { legend: 'How many networks?', tiles: [
        ['n1', 'lanes1', '1× CAN'], ['n2', 'lanes2', '2× CAN or CAN FD'], ['n4', 'lanes4', '3 to 4× CAN FD'], ['diag', 'diag', 'With diagnostics or calibration'], ['ns', 'question', 'Not sure yet'] ] },
      measure: { legend: 'What are you measuring?', tiles: [
        ['temp', 'thermo', 'Temperatures'], ['volt', 'wave', 'Voltages and analogue signals'], ['mixed', 'layers', 'Mixed signals in one module'], ['few', 'few', 'A couple of inputs beside the bus data'] ] },
      both: { legend: 'What are you adding to the logger?', tiles: [
        ['temp', 'thermo', 'Temperatures'], ['volt', 'wave', 'Voltages and analogue signals'], ['mixed', 'layers', 'Mixed signals in one module'] ] },
      remote: { legend: 'What happens to the data?', tiles: [
        ['upload', 'upload', 'Upload the files to the cloud'], ['edge', 'chip', 'Process on the device first'], ['site', 'drive', 'Collect on site, no cellular'] ] },
    };
    var WHY = {
      'rexgen-1': ['One CAN 2.0 channel is all this job needs', 'Records to 8 GB onboard, collected over USB', 'The lowest-cost way into the range'],
      'rexgen-2': ['Two CAN FD channels and LIN as standard', 'Evidence-grade files, IMU GNSS version for motion and position', 'Two analogue and two digital inputs on the logger'],
      'rexgen-air': ['Files upload over LTE, no site visit', 'Two or four CAN FD channels, GNSS and IMU included', 'Onboard storage and USB when you want them'],
      'rexgen-pro': ['Edge compute and gateway functions on the logger', 'Up to four CAN FD, LTE and Wi-Fi, IP65', 'Built to order, quoted per programme'],
      'rebel-ct': ['XCP, CCP and UDS sessions recorded beside the bus data', 'Two CAN 2.0, two CAN FD and two LIN on one timebase', 'Four analogue and three digital inputs, no module needed'],
      'rebel-lt': ['UDS requests and responses land in the log file', 'Two CAN 2.0 channels and K-Line', 'Four analogue inputs and digital I/O on the logger'],
      'k-tc': ['8, 16 or 32 thermocouple channels on the bus', 'Reads into any CAN logger, or logs on its own', 'K, J and T types, 0.001 °C resolution'],
      'k-an8': ['Eight analogue inputs at up to 10 kHz', 'Open collector outputs that switch relays and indicators', 'Read by any CAN logger on the same timebase'],
    };
    WHY[KB] = ['Analogue, thermocouple and digital on one module', 'Trade channels for rate, 8 at 1 kHz to 2 at 10 kHz', 'Read by any CAN logger on the same timebase'];
    var MOD = { temp: ['k-tc', 'for the thermocouples, 8 to 32 channels'], volt: ['k-an8', 'for the analogue inputs and switched outputs'], mixed: [KB, 'for analogue, thermocouple and digital in one module'] };
    function recommend(q1, q2) {
      var R = function (p, alts, why, altsTitle) { return { p: p, alts: alts, why: why || WHY[p], altsTitle: altsTitle }; };
      if (q1 === 'record') {
        if (q2 === 'n1') return R('rexgen-1', ['rexgen-2', 'rexgen-air']);
        if (q2 === 'n4') return R('rexgen-air', ['rebel-ct', 'rexgen-pro'], ['Four CAN FD channels on the 4 CAN version', 'Onboard storage and USB, the LTE upload is there when you want it', 'GNSS and IMU included']);
        if (q2 === 'diag') return R('rebel-ct', ['rebel-lt', 'rexgen-pro']);
        return R('rexgen-2', ['rebel-ct', 'rexgen-air']);
      }
      if (q1 === 'measure') {
        if (q2 === 'few') return R('rexgen-2', ['rebel-lt', 'rebel-ct'], ['Two analogue and two digital inputs on the logger itself', 'Two CAN FD channels and LIN, no module needed', 'Evidence-grade files on one timebase']);
        var m = (MOD[q2] || MOD.temp)[0];
        return R(m, Object.keys(MOD).map(function (k) { return MOD[k][0]; }).filter(function (x) { return x !== m; }));
      }
      if (q1 === 'both') {
        var mm = MOD[q2] || MOD.temp;
        return R('rexgen-2', [mm[0], 'rebel-ct'], WHY['rexgen-2'].slice(0, 2).concat(['Add ' + mm[1].replace(/^for /, 'a module for ')]), 'Pair it with');
      }
      if (q1 === 'remote') {
        if (q2 === 'edge') return R('rexgen-pro', ['rexgen-air']);
        if (q2 === 'site') return R('rexgen-2', ['rexgen-air', 'rexgen-1'], ['Standalone logging, collected over USB when the vehicle returns', 'Two CAN FD channels, GNSS position on the IMU version', 'Evidence-grade files on one timebase']);
        return R('rexgen-air', ['rexgen-pro', 'rexgen-2']);
      }
      return null;
    }
    return { ICON: ICON, Q2: Q2, WHY: WHY, recommend: recommend };
  })();
  var svg = function (name) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + (FINDER.ICON[name] || FINDER.ICON.question) + '</svg>'; };

  function initPanel(panel, root) {
    var V;
    try { V = JSON.parse(panel.querySelector('[data-pc-variants]').textContent); } catch (e) { return; }
    if (!V || !V.length) return;
    var one = function (s) { return panel.querySelector(s); };
    var form = one('[data-pc-cart]'), qty = one('[data-pc-qty]'), radios = $$('[data-pc-opt]', panel);
    var idIn = one('[data-pc-variant-id]'), add = one('[data-pc-add]'), quoteBtn = one('.psx-cfg__actions [data-pc-quote-open]');
    var view = one('[data-pc-view]'), stockSq = one('[data-pc-stock] .psx-sq'), snap = one('[data-pc-snap]');
    var cfgBody = one('[data-pc-config]'), quote = one('[data-pc-quote]'), msg = one('[data-pc-message]'), body = one('[data-pc-body]'), summary = one('[data-pc-quote-summary]');
    var max = parseInt(root.getAttribute('data-max'), 10) || 5;
    var freeFrom = parseInt(root.getAttribute('data-free-from'), 10) || 0, freeTo = parseInt(root.getAttribute('data-free-to'), 10) || Infinity;
    var route = root.hasAttribute('data-pc-route'); /* outside the UK and EU: no prices, the variant JSON carries none */
    var country = one('[data-pc-country]');
    var title = panel.getAttribute('data-title'), url = panel.getAttribute('data-url'), single = V.length === 1;
    var addLabel = add && add.getAttribute('data-label');
    if (!form || !qty) return;

    /* tile labels (value_labels) and option names come from the markup */
    var labels = {}, names = {};
    radios.forEach(function (r) {
      var i = r.getAttribute('data-pc-opt');
      (labels[i] = labels[i] || {})[r.value] = r.closest('label').querySelector('b').textContent;
      names[i] = r.closest('fieldset').querySelector('legend').lastChild.textContent.trim();
    });
    var lbl = function (i, val) { return (labels[i] && labels[i][val]) || val; };
    /* options without tiles (a single value) stay out of the configuration text, as on the server */
    var label = function (v) { return v.options.map(function (o, i) { return labels[i] && lbl(i, o); }).filter(Boolean).join(', '); };
    var count = function () { return Math.min(max, Math.max(1, parseInt(qty.value, 10) || 1)); };

    function picks() {
      var p = [];
      radios.forEach(function (r) { if (r.checked) p[+r.getAttribute('data-pc-opt')] = r.value; });
      return p;
    }
    function fits(v, p) { return p.every(function (x, i) { return v.options[i] === x; }); }
    /* the variant with options[i] = val that keeps the most other picks (earlier options win ties), then in stock, then cheapest */
    function best(i, val, p) {
      var top = null, key = -1;
      V.forEach(function (v) {
        if (v.options[i] !== val) return;
        var kept = 0, w = 0;
        p.forEach(function (x, j) { if (j !== i && v.options[j] === x) { kept++; w += 1 << (8 - j); } });
        var k = kept * 1e4 + w * 10 + (v.available ? 1 : 0);
        if (k > key || (k === key && v.price < top.price)) { top = v; key = k; }
      });
      return top;
    }
    function current() {
      var p = picks();
      return V.filter(function (v) { return fits(v, p); })[0] || V.filter(function (v) { return v.available; })[0] || V[0];
    }
    function setPicks(v) { radios.forEach(function (r) { if (v.options[+r.getAttribute('data-pc-opt')] === r.value) r.checked = true; }); }
    /* the configuration block appended to the visitor's note in the posted body */
    function block(v, q) {
      return [MARK, 'Product: ' + title]
        .concat(single ? [] : ['Configuration: ' + label(v)], v.sku ? ['Part number: ' + v.sku] : [], ['Quantity: ' + q],
          country && country.value ? ['Country: ' + country.value] : [],
          v.price ? ['Price shown: ' + v.pt + ' each, ' + tot(v, q) + (v.inc ? ' including VAT' : '')] : [])
        .join('\n');
    }

    function render(settle) {
      var v = current(), p = picks(), q = count(), quoteOnly = !v.price, overStock = v.inv !== null && v.inv !== undefined && q > v.inv, buy = v.available && !quoteOnly && !overStock, total = v.price * q;
      if (settle || qty.value !== '') qty.value = q; /* an emptied field stays empty while typing */
      radios.forEach(function (r) {
        var i = +r.getAttribute('data-pc-opt'), b = best(i, r.value, p), tile = r.closest('label'), sw = [];
        if (!b) return;
        tile.querySelector('[data-pc-opt-price]').textContent = b.price ? b.pt + (b.inc ? ' inc VAT' : '') : 'On request';
        p.forEach(function (x, j) { if (j !== i && b.options[j] !== x) sw.push(names[j] + ' to ' + lbl(j, b.options[j])); });
        tile.classList.toggle('is-adjust', sw.length > 0);
        if (sw.length) tile.title = 'Selecting ' + lbl(i, r.value) + ' switches ' + sw.join(' and ');
        else tile.removeAttribute('title');
        tile.classList.toggle('psx-opt--off', !b.available);
      });
      if (idIn) idIn.value = v.id;
      one('[data-pc-sku]').textContent = v.sku || '';
      one('[data-pc-total]').classList.toggle('is-text', quoteOnly);
      one('[data-pc-built]').hidden = !quoteOnly;
      /* both figures of the price pair and the import VAT note per variant and quantity,
         precomputed in Liquid (snippets/price-vat.liquid part 'pair') */
      var pair = one('[data-pc-pair]'), xv = (!quoteOnly && v.xv && v.xv[q - 1]) || '', note = one('[data-pc-note]');
      pair.hidden = quoteOnly;
      if (!quoteOnly) {
        pair.querySelector('[data-vat-main]').textContent = tot(v, q);
        var exAmt = pair.querySelector('[data-vat-ex]');
        if (exAmt) exAmt.textContent = xv;
        pair.querySelectorAll('[data-vat-exfig], [data-vat-sep], [data-vat-inclbl]').forEach(function (n) { n.hidden = !xv; });
      }
      if (note) note.hidden = quoteOnly || !v.nt;
      one('[data-pc-config-text]').textContent = (single ? title : label(v)) + (q > 1 && !quoteOnly ? ', ' + q + ' units at ' + v.pt + (v.inc ? ' inc VAT' : '') : '');
      if (view) view.href = url + (single ? '' : '?variant=' + v.id);
      /* the free delivery rule is in GBP, so other currencies get no delivery sentence */
      /* the stock line doubles as the reason Add to cart is off (first match wins) */
      var stockText = quoteOnly ? 'This configuration is quoted individually.'
        : !v.available ? "Out of stock. Request a quote and we'll confirm a delivery date."
        : overStock ? 'We have ' + v.inv + " in stock. For more, request a quote and we'll confirm a delivery date."
        : 'In stock.' + (currency() !== 'GBP' ? '' : total < freeFrom ? ' Free UK delivery from £' + Math.round(freeFrom / 100) + '.' : total <= freeTo ? ' Free UK delivery on this order.' : '');
      if (one('[data-pc-stock-text]').textContent !== stockText) one('[data-pc-stock-text]').textContent = stockText;
      if (stockSq) stockSq.style.background = buy ? 'var(--psx-green)' : '#a1a1aa';
      if (add) {
        add.disabled = !buy;
        add.textContent = v.available ? addLabel : 'Out of stock';
        add.classList.toggle('psx-btn--dark', buy);
        add.classList.toggle('psx-btn--ghost', !buy);
      }
      if (quoteBtn) {
        quoteBtn.classList.toggle('psx-btn--dark', !buy);
        quoteBtn.classList.toggle('psx-btn--ghost', buy);
      }
      /* quote form: hidden fields and summary always follow the configuration */
      var f = { product: title, configuration: single ? '' : label(v), part_number: v.sku || '', quantity: q, unit_price: v.price ? v.pt : '' };
      $$('[data-pc-f]', panel).forEach(function (el) { el.value = f[el.getAttribute('data-pc-f')]; });
      summary.textContent = [title].concat(single ? [] : [f.configuration], ['qty ' + q], route ? [] : [quoteOnly ? 'built to order' : tot(v, q) + (v.inc ? ' inc VAT' : '')]).join(', ');
    }

    form.addEventListener('change', function (e) {
      var r = e.target;
      if (!r.hasAttribute('data-pc-opt')) return;
      var i = +r.getAttribute('data-pc-opt'), p = picks(), b = null;
      if (!V.some(function (v) { return fits(v, p); })) b = best(i, r.value, p);
      if (snap) {
        snap.textContent = b ? p.map(function (x, j) {
          if (j === i || b.options[j] === x) return '';
          var only = V.every(function (v) { return v.options[i] !== r.value || v.options[j] === b.options[j]; });
          return names[j] + ' switched to ' + lbl(j, b.options[j]) + (only ? ', the only ' + low(names[j]) + ' available with ' + lbl(i, r.value) : ' to match ' + lbl(i, r.value)) + '.';
        }).filter(Boolean).join(' ') : '';
      }
      if (b) setPicks(b);
      render();
      emit('configurator_option', { product: title, option: names[i], value: r.value });
    });
    one('[data-pc-qty-minus]').addEventListener('click', function () { qty.value = count() - 1; render(true); });
    one('[data-pc-qty-plus]').addEventListener('click', function () { qty.value = count() + 1; render(true); });
    qty.addEventListener('input', function () { render(); });
    qty.addEventListener('blur', function () { render(true); });
    form.addEventListener('submit', function (e) {
      var v = current(), q = count();
      qty.value = q;
      if (!v.available || !v.price || (v.inv !== null && v.inv !== undefined && q > v.inv)) { e.preventDefault(); return; }
      if (root.getAttribute('data-buy-action') === 'product') { e.preventDefault(); window.location.href = view.href; return; }
      emit('configurator_add_to_cart', { product: title, variant_id: v.id, sku: v.sku || '', quantity: q, total: v.price * q / 100 });
    });
    if (view) view.addEventListener('click', function () { emit('configurator_view_product', { product: title }); });

    /* step 4 opens and closes the quote form through these; the wizard owns the step */
    var barTitle = one('[data-pc-bar-title]');
    panel.__pcOpen = function () {
      render(true); /* re-derives every hidden field and the summary from this panel */
      cfgBody.hidden = true;
      quote.hidden = false;
      if (barTitle) barTitle.textContent = barTitle.getAttribute('data-pc-bar-quote');
      fadeUp(quote);
      emit('configurator_quote_open', { product: title });
    };
    panel.__pcClose = function () {
      quote.hidden = true;
      cfgBody.hidden = false;
      if (barTitle) barTitle.textContent = barTitle.getAttribute('data-pc-bar-title');
      fadeUp(cfgBody);
    };
    $$('[data-pc-quote-open]', panel).forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); if (root.__pcQuote) root.__pcQuote(panel); });
    });
    /* the body posts the visitor's note, two newlines, then the configuration block; the note field itself never shows
       the block. Captured on the panel so it runs before the lead mirror's own submit listener on the form reads the body */
    var quoteForm = quote.querySelector('form');
    panel.addEventListener('submit', function (e) {
      if (e.target !== quoteForm) return;
      /* a second click while the first post is on its way: swallowed here, before the captcha sees it */
      if (quoteForm.hasAttribute('data-pc-sending')) { e.preventDefault(); e.stopPropagation(); return; }
      var note = msg ? msg.value.trim() : '';
      try { render(true); } catch (x) {} /* hidden fields always post this panel's configuration, whatever refilled them */
      note = note.split(MARK)[0].trim(); /* a pasted look-alike block can never replace the real one */
      if (body) body.value = (note ? note + '\n\n' : '') + block(current(), count());
      try { sessionStorage.setItem('pcQuoteSummary', summary.textContent); } catch (x) {}
      emit('configurator_quote_submit', { product: title, configuration: single ? '' : label(current()), quantity: count() });
      /* the captcha and the post take a moment before the page goes: the button says so and takes no second click;
         released if the page comes back from the cache or the post never leaves */
      var btn = quoteForm.querySelector('[type="submit"]');
      if (!btn) return;
      var idle = btn.textContent;
      var release = function () { quoteForm.removeAttribute('data-pc-sending'); btn.textContent = idle; btn.removeAttribute('aria-disabled'); btn.style.minWidth = ''; };
      btn.style.minWidth = btn.offsetWidth + 'px'; /* the shorter label never shrinks the button */
      quoteForm.setAttribute('data-pc-sending', '');
      btn.setAttribute('aria-disabled', 'true');
      btn.textContent = 'Sending';
      setTimeout(release, 15000);
      window.addEventListener('pageshow', function (ev) { if (ev.persisted) release(); }, { once: true });
    }, true);
    /* returned to this form (#PcQuote-<handle>, or an error): restore the configuration from the hidden fields, which
       Shopify's captcha refill restores, and the note from the refilled body (its configuration block cut off) */
    panel.__pcReopen = function () {
      /* the posted body (echoed by Shopify on an error, refilled after a challenge) names the configuration; the hidden
         fields are the fallback, since only the challenge refill restores those */
      var posted = body ? body.value : '', c = /^Configuration: (.+)$/m.exec(posted), n = /^Quantity: (\d+)$/m.exec(posted);
      var cf = one('[data-pc-f="configuration"]'), qf = one('[data-pc-f="quantity"]');
      var want = c ? c[1] : cf && cf.value, num = n ? n[1] : qf && qf.value;
      var v = want && V.filter(function (x) { return label(x) === want; })[0];
      if (v) setPicks(v);
      if (num && /^\d+$/.test(num)) qty.value = num;
      if (msg && !msg.value && body && body.value) msg.value = body.value.split(MARK)[0].trim();
    };
    /* Shopify echoes errors and the posted note into every contact form: clear them from the other panels */
    panel.__pcReset = function () {
      var e = one('.pc-quote__errors');
      if (e) e.parentNode.removeChild(e);
      if (msg) msg.value = '';
      if (body) body.value = '';
    };
    render(true);
  }

  function init(root) {
    if (root.__pcReady) return;
    root.__pcReady = true;
    root.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-pc-industry]');
      if (!a) return;
      var st = root.querySelector('[data-pc-stage]');
      emit('configurator_industry', { industry: a.getAttribute('data-pc-industry'), position: $$('[data-pc-industry]', root).indexOf(a) + 1, step: +(st && st.getAttribute('data-step')) || 0 });
    });
    var stage = root.querySelector('[data-pc-stage]'), panels = $$('[data-pc-panel]', root), byHandle = {};
    panels.forEach(function (p) { byHandle[p.getAttribute('data-handle')] = p; initPanel(p, root); });
    var formId = /^#PcQuote-[\w-]+$/.test(location.hash) ? location.hash.slice(1) : '';

    if (root.hasAttribute('data-pc-sent')) {
      /* the success window (styled, receipt-filled and animated without waiting for this script): name the sent product
         and point the URL back at the configurator so a refresh (or the again button) shows it instead of this window */
      var titles = {}, again = root.querySelector('[data-pc-again]');
      try { titles = JSON.parse(root.querySelector('[data-pc-titles]').textContent); } catch (e) {}
      if (formId && has(titles, formId) && root.hasAttribute('data-pc-receipt')) emit('configurator_quote_sent', { product: titles[formId] });
      try {
        var u = new URL(location.href);
        u.searchParams.delete('contact_posted');
        history.replaceState(history.state, '', u.pathname + u.search + '#configurator');
      } catch (e) {}
      if (again) again.addEventListener('click', function (e) { e.preventDefault(); location.reload(); });
      return;
    }

    var steps = [null, root.querySelector('[data-pc-screen="1"]'), root.querySelector('[data-pc-screen="2"]'), root.querySelector('[data-pc-screen="3"]')];
    var step2 = root.querySelector('[data-pc-step2]'), backBtn = root.querySelector('[data-pc-back]'), result = root.querySelector('[data-pc-result]');
    if (!steps[1] || !steps[2] || !steps[3] || !step2 || !backBtn || !result) return;
    var text = result.querySelector('[data-pc-result-text]'), alts = result.querySelector('[data-pc-alts]'), line = result.querySelector('.pc-result__line');
    var state = { step: 1, q1: '', q2: '', rec: null, cands: [], cur: '' };
    var known = function (h) { return has(byHandle, h); };
    var title = function (h) { return byHandle[h].getAttribute('data-title'); };

    function renderStep2(q1) {
      var d = has(FINDER.Q2, q1) && FINDER.Q2[q1];
      if (!d) return;
      var n = d.tiles.length;
      step2.innerHTML = '<fieldset><legend><span class="psx-mono">02</span> ' + esc(d.legend) + '</legend><div class="psx-tiles psx-tiles--' + n + '">' + d.tiles.map(function (t) {
        return '<label class="psx-tile' + (n > 4 ? ' psx-tile--compact' : '') + '"><input type="radio" name="pc-q2" value="' + esc(t[0]) + '"><span class="psx-tile__art">' + svg(t[1]) + '</span><span class="psx-tile__label">' + esc(t[2]) + '</span></label>';
      }).join('') + '</div></fieldset>';
    }
    /* the hash names what a reload should show: the product from step 3 on, the ticked answers from step 2 on */
    function setHash() {
      var q = (state.step > 2 ? [['p', state.cur]] : []).concat(state.step > 1 ? [['q1', state.q1], ['q2', state.q2]] : [])
        .filter(function (x) { return x[1]; }).map(function (x) { return x[0] + '=' + x[1]; }).join('&');
      try { history.replaceState(history.state, '', location.pathname + location.search + '#configurator' + (q ? '?' + q : '')); } catch (e) {}
    }
    function showPanel(h) {
      panels.forEach(function (p) {
        var on = p === byHandle[h];
        p.hidden = !on;
        if (on) {
          p.removeAttribute('inert');
          p.removeAttribute('aria-hidden');
          $$('img[loading="lazy"]', p).forEach(function (img) { img.loading = 'eager'; });
        } else {
          p.setAttribute('inert', '');
          p.setAttribute('aria-hidden', 'true');
        }
      });
    }
    /* the recommendation's alternatives as chips; rebuilt only for a new answer or a pick, never on a chip click, so a
       chip keeps keyboard focus when it is chosen */
    function chips(list) {
      var altTitle = (state.rec && state.rec.altsTitle) || 'Also consider';
      alts.innerHTML = list.length ? '<span class="psx-mono pc-result__alts-title">' + esc(altTitle) + '</span>' + list.map(function (k) {
        return '<button type="button" class="psx-chip" data-pc-alt="' + esc(k) + '" data-range="' + esc(byHandle[k].getAttribute('data-range')) + '" aria-pressed="false"><span class="psx-sq"></span>' + esc(title(k)) + '</button>';
      }).join('') : '';
    }
    /* via: finder (the recommendation), alt (a chip), pick (a quote return, a restored link, the theme editor) */
    function choose(h, via, quiet) {
      if (!known(h)) return;
      if (via === 'pick') { state.cands = []; chips([]); }
      state.cur = h;
      var best = !!state.rec && h === state.rec.p && via !== 'pick';
      text.textContent = (best ? 'Best match: ' : 'Your pick: ') + title(h);
      $$('[data-pc-alt]', alts).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-pc-alt') === h ? 'true' : 'false'); });
      var why = best ? state.rec.why : (has(FINDER.WHY, h) ? FINDER.WHY[h] : []);
      byHandle[h].querySelector('[data-pc-why]').innerHTML = why.map(function (w) { return '<li><span class="psx-sq"></span><span>' + esc(w) + '</span></li>'; }).join('');
      showPanel(h);
      stage.setAttribute('data-range', byHandle[h].getAttribute('data-range'));
      if (state.step > 2) setHash();
      if (!quiet) emit('configurator_product', { product: title(h), via: via });
    }
    /* one step view at a time; the views share one grid cell, so the leaving one fades out over the arriving one,
       inert, then hides. Steps 3 and 4 share the third view (4 is the panel with its quote form open) */
    function show(n, now) {
      var to = steps[Math.min(n, 3)], from = steps[Math.min(state.step, 3)], dx = n > state.step ? 28 : -28;
      if (to !== from) {
        if (to.__pcOut) { to.__pcOut.cancel(); to.__pcOut = null; }
        to.classList.remove('is-leaving');
        to.removeAttribute('inert');
        to.hidden = false;
        from.setAttribute('inert', '');
        if (now || reduced || !from.animate) from.hidden = true;
        else {
          slideIn(to, dx);
          if (n === 3) rise(to);
          /* the views share one grid cell, so the leaving view can slip out over the arriving one where the stage has a
             fixed height; on phones (content height) it just goes, or the cell would briefly hold both */
          if (matchMedia('(min-width: 900px)').matches) {
            from.classList.add('is-leaving');
            var out = from.__pcOut = from.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateX(' + (-dx / 2) + 'px)' }], { duration: 200, easing: 'cubic-bezier(.4, 0, 1, 1)', fill: 'forwards' });
            out.onfinish = function () { from.hidden = true; from.classList.remove('is-leaving'); from.__pcOut = null; out.cancel(); };
          } else from.hidden = true;
        }
      }
      state.step = n;
      stage.setAttribute('data-step', n);
      stage.setAttribute('data-range', n > 2 && state.cur ? byHandle[state.cur].getAttribute('data-range') : 'green');
    }
    /* focus follows the step: its checked (else first) tile, the result line, the Name field */
    function go(n) {
      var panel = state.cur && byHandle[state.cur];
      if (n === 4 && !panel) return;
      if (state.step === 4 && n !== 4 && panel) panel.__pcClose();
      if (n === 4 && state.step !== 4) panel.__pcOpen();
      show(n);
      setHash();
      var el = n === 1 ? steps[1].querySelector('input:checked') || steps[1].querySelector('input')
        : n === 2 ? step2.querySelector('input:checked') || step2.querySelector('input')
        : n === 3 ? line : panel.querySelector('[name="contact[name]"]');
      if (el) el.focus();
    }
    function answer(q2) {
      state.q2 = q2;
      state.rec = FINDER.recommend(state.q1, q2);
      state.cands = state.rec ? [state.rec.p].concat(state.rec.alts).filter(known) : [];
      chips(state.rec ? state.cands.filter(function (k) { return k !== state.rec.p; }) : []);
      if (state.cands[0]) choose(state.cands[0], state.cands[0] === state.rec.p ? 'finder' : 'alt');
      else { state.cur = ''; showPanel(''); text.textContent = 'None of the products here fits that job.'; }
      go(3);
    }
    function take(r) {
      if (r.name === 'pc-q2') return answer(r.value);
      if (r.value !== state.q1) {
        state.q1 = r.value;
        state.q2 = '';
        state.rec = null;
        state.cands = [];
        renderStep2(r.value);
      }
      go(2);
    }

    /* a tile chosen by pointer advances at once; the arrow keys only move the selection (the radio group's own
       behaviour) and Enter or Space on the focused tile advances */
    var key = '', tile = function (el) { return el && (el.name === 'pc-q1' || el.name === 'pc-q2'); };
    root.addEventListener('pointerdown', function () { key = ''; }, true);
    root.addEventListener('keydown', function (e) {
      key = e.key;
      if (!tile(e.target) || (e.key !== 'Enter' && e.key !== ' ')) return;
      e.preventDefault();
      e.target.checked = true;
      take(e.target);
    });
    root.addEventListener('click', function (e) {
      var arrow = /^Arrow/.test(key);
      key = '';
      if (tile(e.target) && !arrow) take(e.target);
    });
    backBtn.addEventListener('click', function () { go(state.step === 4 ? 3 : state.step === 3 && state.q1 ? 2 : 1); });
    alts.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-pc-alt]');
      if (!b) return;
      /* a pressed chip toggles back to the recommendation */
      if (b.getAttribute('aria-pressed') === 'true' && state.rec && known(state.rec.p)) choose(state.rec.p, 'finder');
      else choose(b.getAttribute('data-pc-alt'), 'alt');
    });
    root.__pcQuote = function (panel) { if (panel === byHandle[state.cur]) go(4); };
    root.__pcChoose = function (panel) {
      if (state.step === 4 && byHandle[state.cur]) byHandle[state.cur].__pcClose();
      choose(panel.getAttribute('data-handle'), 'pick', true);
      show(3, true);
    };

    /* a shared or reloaded #configurator?p=<handle>&q1=<answer>&q2=<answer>: tick the answers, show the matching step */
    var m = /^#configurator\?([\w=&-]*)$/.exec(location.hash);
    if (m) {
      var q = {};
      m[1].split('&').forEach(function (kv) { var a = kv.split('='); if (a[1]) q[a[0]] = a[1]; });
      var r1 = has(FINDER.Q2, q.q1) && steps[1].querySelector('input[name="pc-q1"][value="' + q.q1 + '"]');
      if (r1) {
        r1.checked = true;
        state.q1 = q.q1;
        renderStep2(q.q1);
        var r2 = FINDER.Q2[q.q1].tiles.some(function (t) { return t[0] === q.q2; }) && step2.querySelector('input[name="pc-q2"][value="' + q.q2 + '"]');
        if (r2) {
          r2.checked = true;
          state.q2 = q.q2;
          state.rec = FINDER.recommend(state.q1, state.q2);
        }
      }
      if (known(q.p)) {
        var via = !state.rec ? 'pick' : q.p === state.rec.p ? 'finder' : state.rec.alts.indexOf(q.p) > -1 ? 'alt' : 'pick';
        if (via !== 'pick') {
          state.cands = [state.rec.p].concat(state.rec.alts).filter(known);
          chips(state.cands.filter(function (k) { return k !== state.rec.p; }));
        }
        choose(q.p, via, true);
        show(3, true);
      } else if (state.q1) show(2, true);
      if (state.step > 1) stage.scrollIntoView({ block: 'nearest' });
    }

    /* one view per page: any part of the section on screen (the header from above, a quote form on a return) */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { io.disconnect(); emit('configurator_view', {}); }
      }, { threshold: 0 });
      io.observe(root);
    } else emit('configurator_view', {});

    /* back from a quote post (#PcQuote-<handle>) or a failed one: step 4 for that product, focus any errors */
    ready(function () {
      var hashForm = formId && document.getElementById(formId), errs = root.hasAttribute('data-pc-open-quote') && root.querySelector('.pc-quote__errors');
      var target = hashForm && root.contains(hashForm) ? hashForm.closest('[data-pc-panel]') : errs ? errs.closest('[data-pc-panel]') : null;
      if (!target || !target.__pcReopen) return;
      /* Shopify echoes errors and refills the posted fields into every contact form: the other panels start fresh */
      panels.forEach(function (p) { if (p !== target && p.__pcReset) p.__pcReset(); });
      choose(target.getAttribute('data-handle'), 'pick', true);
      target.__pcReopen();
      target.__pcOpen();
      show(4, true);
      setHash();
      /* the browser's own fragment handling blurs whatever is focused until the page has loaded, so focus after it */
      var el = target.querySelector('.pc-quote__errors') || target.querySelector('[name="contact[name]"]');
      var focus = function () { if (el) el.focus(); };
      if (document.readyState === 'complete') focus();
      else window.addEventListener('load', function () { setTimeout(focus, 0); }, { once: true });
    });
  }

  function boot(scope) { $$('[data-pc]', scope).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target.closest && e.target.closest('[data-pc-panel]'), root = panel && panel.closest('[data-pc]');
    if (root && root.__pcChoose) root.__pcChoose(panel);
  });
})();
